module.exports = __webpack_public_path__ + "img/export.1085fec5.svg";